import { Component, Inject, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class OlivorFooterComponent implements OnInit {

  isHMTheme = true;
  public lat: number = 40.678178;
  public lng: number = -73.944158;
  public zoom: number = 12;
  storeDetailsJson = {};
  storeDetails = {};
  logoWidth: any = 40;
  fooColWidth: any = 20;
  loggedIn;
  featureTags = {}
  constructor(private apiService: ApiService,
    public router: Router, @Inject(DOCUMENT) private document: Document) { }

  ngOnInit() {
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
    this.loggedIn = this.apiService.loggedIn();

    this.logoWidth = this.isHMTheme ? '320px' : 40;
    this.fooColWidth = this.isHMTheme ? '216px' : 20;
    this.getStore();
  }
  getStore() {
    this.apiService.getStoreDetails().subscribe(result => {
      if (result['response']['status'] === 1) {
        this.storeDetailsJson = result['response']['data']['store_json'];
        this.storeDetails = result['response']['data']['store']
      }
    }, (error) => {
      if (error) {
        console.log(error);
      }
    })
  }

  GetCMSPage(name) {
    this.apiService.setLoader(true);
    let storeId = JSON.parse(sessionStorage.getItem('store')).id;
    this.apiService.getContentItems({ type: 'pages', store_id: storeId, item_handle: name }).subscribe(result => {
      if (result['response']['status'] === 1) {
        this.apiService.SetCmsPage(result['response']['data']);
        if (result['response']['data'].length > 0) {
          const Htmlcontent = result['response']['data'];
          this.apiService.setLoader(false);
        }
      }
    });
  }
  subscribe() { }
  generateAbsoluteLink(relativePath: string): string {
    return `${this.document.location.origin}/${relativePath}`;
  }
}